export const GTM_EVENTS = {
  // Page views
  AUTH_PAGE_VIEW: 'auth_page_view',

  // Login events
  LOGIN_ATTEMPT: 'login_attempt',
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAILURE: 'login_failure',

  // Registration funnel events
  SIGNUP_START: 'signup_start',
  SIGNUP_FIELD_COMPLETE: 'signup_field_complete',
  SIGNUP_SUBMIT: 'signup_submit',
  SIGNUP_SUCCESS: 'signup_success',
  SIGNUP_FAILURE: 'signup_failure',
  EMAIL_VERIFICATION_REDIRECT: 'email_verification_redirect',

  // SSO events
  SSO_BUTTON_CLICK: 'sso_button_click',
  SSO_CALLBACK_SUCCESS: 'sso_callback_success',
  SSO_CALLBACK_FAILURE: 'sso_callback_failure',
} as const;

export const SIGNUP_FIELDS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  PASSWORD: 'password',
  FUNCTION: 'function',
} as const;
